module.exports = __webpack_public_path__ + "img/Open discussions.e33b2736.png";